/* angular:styles/component:scss;73f617775dc2917d0a5db6bb69f9ed440cd8af97c5c31680230e94f6ef2766ee;/home/vsts/work/1/s/Autocare.Api/ClientApp/src/app/module/users/types/formly-field-date-range-min.component.ts */
::ng-deep .p-inputgroup-addon {
  background: #fff !important;
}
.formly-validation-message {
  color: #e24c4c;
  font-size: 13px;
  margin-top: 4px;
  font-weight: 500;
}
/*# sourceMappingURL=formly-field-date-range-min.component-MOFXITOG.css.map */
